import { MgState } from '@types';
import { createSelector } from 'reselect';
import { Paths } from '@constants/paths';
import { lastAnswerIdSelector } from '@selectors/user';
import { canAllowLettersPageSelector } from '@selectors/app/index';

const getRegisteredRoute = (store: MgState): string => store?.app.registeredRoute;
export const isLoggedInSelector = (store: MgState): boolean => store?.auth?.isLoggedIn;

export const registeredRouteSelector = createSelector(
  [getRegisteredRoute, canAllowLettersPageSelector, lastAnswerIdSelector],
  (route, canAllowLetterPage, lastAnswerId): string => {
    const isValidRoute =
      route &&
      (route.includes(Paths.LETTERS) ||
        route.includes(Paths.QUESTIONNAIRE) ||
        route.includes(Paths.ANSWERS) ||
        route.includes(Paths.ANSWER) ||
        route.includes(Paths.DASHBOARD) ||
        route.includes(Paths.CHANGELOG) ||
        route.includes(Paths.NOT_FOUND));

    if (isValidRoute) {
      return route;
    }

    if (canAllowLetterPage) {
      return Paths.LETTERS;
    }

    if (lastAnswerId) {
      return `${Paths.ANSWER}/${lastAnswerId}`;
    } else {
      return `${Paths.NOT_FOUND}`;
    }
  }
);
